import React, { useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

function ApprovalModal({ application, onConfirm, onClose }) {
  const [subscriptionMonths, setSubscriptionMonths] = useState(12);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm(subscriptionMonths);
    setLoading(false);
  };

  const calculateEndDate = (months) => {
    const date = new Date();
    date.setMonth(date.getMonth() + months);
    return date.toLocaleDateString('az-AZ', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };

  return (
    <>
      <div style={styles.overlay} onClick={onClose}></div>
      <div style={styles.modal}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerIcon}>
            <FaCheckCircle size={40} color="#4CAF50" />
          </div>
          <h2 style={styles.title}>✅ Müraciəti Təsdiqlə</h2>
        </div>

        <div style={styles.content}>
          {/* Business Info */}
          <div style={styles.businessInfo}>
            <h3 style={styles.businessName}>{application.company_name}</h3>
            <p style={styles.businessDetail}>VÖEN: {application.voen}</p>
            <p style={styles.businessDetail}>Email: {application.email}</p>
          </div>

          {/* Warning */}
          <div style={styles.warningBox}>
            <p style={styles.warningText}>
              ⚠️ Təsdiqlədikdən sonra bu biznes üçün hesab yaradılacaq və email göndəriləcək.
            </p>
          </div>

          {/* Subscription Options */}
          <div style={styles.subscriptionSection}>
            <h4 style={styles.subscriptionTitle}>Abunəlik Müddəti Seç:</h4>

            <div style={styles.optionsGrid}>
              <div
                onClick={() => setSubscriptionMonths(1)}
                style={{
                  ...styles.optionCard,
                  ...(subscriptionMonths === 1 ? styles.optionCardActive : {}),
                }}
              >
                <div style={styles.optionRadio}>
                  {subscriptionMonths === 1 && <div style={styles.optionRadioInner}></div>}
                </div>
                <div>
                  <p style={styles.optionTitle}>1 Ay</p>
                  <p style={styles.optionPrice}>Trial / Test</p>
                </div>
              </div>

              <div
                onClick={() => setSubscriptionMonths(3)}
                style={{
                  ...styles.optionCard,
                  ...(subscriptionMonths === 3 ? styles.optionCardActive : {}),
                }}
              >
                <div style={styles.optionRadio}>
                  {subscriptionMonths === 3 && <div style={styles.optionRadioInner}></div>}
                </div>
                <div>
                  <p style={styles.optionTitle}>3 Ay</p>
                  <p style={styles.optionPrice}>Qısa Müddət</p>
                </div>
              </div>

              <div
                onClick={() => setSubscriptionMonths(6)}
                style={{
                  ...styles.optionCard,
                  ...(subscriptionMonths === 6 ? styles.optionCardActive : {}),
                }}
              >
                <div style={styles.optionRadio}>
                  {subscriptionMonths === 6 && <div style={styles.optionRadioInner}></div>}
                </div>
                <div>
                  <p style={styles.optionTitle}>6 Ay</p>
                  <p style={styles.optionPrice}>Orta Müddət</p>
                </div>
              </div>

              <div
                onClick={() => setSubscriptionMonths(12)}
                style={{
                  ...styles.optionCard,
                  ...(subscriptionMonths === 12 ? styles.optionCardActive : {}),
                }}
              >
                <div style={styles.optionRadio}>
                  {subscriptionMonths === 12 && <div style={styles.optionRadioInner}></div>}
                </div>
                <div>
                  <p style={styles.optionTitle}>12 Ay (1 İl)</p>
                  <p style={styles.optionPrice}>✨ Tövsiyə</p>
                </div>
              </div>
            </div>

            {/* End Date Info */}
            <div style={styles.endDateInfo}>
              <p style={styles.endDateLabel}>Abunəlik Bitəcək:</p>
              <p style={styles.endDateValue}>{calculateEndDate(subscriptionMonths)}</p>
            </div>
          </div>

          {/* Actions Summary */}
          <div style={styles.summaryBox}>
            <h4 style={styles.summaryTitle}>Təsdiq edildikdə:</h4>
            <ul style={styles.summaryList}>
              <li>✅ Business hesabı yaradılacaq</li>
              <li>📧 Email bildirişi göndəriləcək</li>
              <li>🔐 Business Panel-ə giriş açılacaq</li>
              <li>📅 Abunəlik {subscriptionMonths} ay aktiv olacaq</li>
              <li>📊 Business dashboard-a çıxış</li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <button onClick={onClose} style={styles.btnCancel} disabled={loading}>
            Ləğv Et
          </button>
          <button onClick={handleConfirm} style={styles.btnConfirm} disabled={loading}>
            {loading ? 'Təsdiq edilir...' : '✅ Təsdiqlə və Hesab Yarat'}
          </button>
        </div>
      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 2000,
  },
  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '16px',
    width: '95%',
    maxWidth: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    zIndex: 2001,
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  },
  header: {
    padding: '30px',
    borderBottom: '2px solid #F0F0F0',
    textAlign: 'center',
  },
  headerIcon: {
    marginBottom: '15px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    margin: 0,
  },
  content: {
    padding: '30px',
  },
  businessInfo: {
    backgroundColor: '#F8F9FA',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  businessName: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '10px',
  },
  businessDetail: {
    fontSize: '14px',
    color: '#666',
    margin: '5px 0',
  },
  warningBox: {
    backgroundColor: '#FFF3E0',
    padding: '15px',
    borderRadius: '8px',
    border: '2px solid #FF9800',
    marginBottom: '25px',
  },
  warningText: {
    fontSize: '14px',
    color: '#E65100',
    margin: 0,
    fontWeight: '500',
  },
  subscriptionSection: {
    marginBottom: '25px',
  },
  subscriptionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '15px',
  },
  optionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '15px',
    marginBottom: '20px',
  },
  optionCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '15px',
    border: '2px solid #E0E0E0',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  optionCardActive: {
    backgroundColor: '#E8F5E9',
    borderColor: '#4CAF50',
  },
  optionRadio: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: '2px solid #E0E0E0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  optionRadioInner: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: '#4CAF50',
  },
  optionTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    margin: 0,
  },
  optionPrice: {
    fontSize: '12px',
    color: '#666',
    margin: 0,
  },
  endDateInfo: {
    backgroundColor: '#E3F2FD',
    padding: '15px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  endDateLabel: {
    fontSize: '14px',
    color: '#666',
    margin: 0,
    fontWeight: '600',
  },
  endDateValue: {
    fontSize: '16px',
    color: '#1565C0',
    margin: 0,
    fontWeight: 'bold',
  },
  summaryBox: {
    backgroundColor: '#F8F9FA',
    padding: '20px',
    borderRadius: '12px',
  },
  summaryTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '12px',
  },
  summaryList: {
    margin: 0,
    paddingLeft: '20px',
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.8',
  },
  footer: {
    padding: '20px 30px',
    borderTop: '2px solid #F0F0F0',
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
  },
  btnCancel: {
    padding: '12px 24px',
    backgroundColor: '#E0E0E0',
    color: '#1A1A2E',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  btnConfirm: {
    padding: '12px 24px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
};

export default ApprovalModal;